// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//Test comments

export const environment = {
  production: false,
  batchBaseURL: 'https://mdm-batch-submit-stage.s3.ap-south-1.amazonaws.com/',
  replacementPdfbatchBaseURL: 'https://mdm-batch-submit-stage.s3.ap-south-1.amazonaws.com/AMR/REPLACEMENT/PDF/',
  amrS3BaseUrl: 'https://mdmamr-stage.s3.ap-south-1.amazonaws.com/',
  s3ImageBaseURL: 'https://mdmamr-stage.s3.ap-south-1.amazonaws.com/',
  s3ImageBaseAmrURL: 'https://s3-ap-south-1.amazonaws.com/mdmamr-stage/',
  uiV2BaseURL: 'https://mdm.apps.console-rsu.rsutilities.com/',
  s3PdfGenURL: 'https://pdfgeneratestage-tools.apps.rsu.rsutilities.com/',
  // The standalone pdfgenerateinspection microservice (separate repo from pdfgenerate — Inspection
  // no longer shares Meter Replacement's service). Deployed on OpenShift (namespace `tools`).
  s3PdfGenInspectionURL: 'https://pdfgenerateinspection-tools.apps.rsu.rsutilities.com/',
  // apiV2Url: 'https://mdmapi.rsutilities.com/api',
  apiV2Url: 'https://mdmapistage.rsutilities.com/api',
  // apiV2Url: 'https://localhost:44357/api',
  // apiV2Url: 'https://mdmapistage-mdm-amr-staging.apps.rsu.rsutilities.com/api',
  // apiV2Url: 'https://mdmapidev-mdm-amr-dev.apps.rsu.rsutilities.com/api',
  region: "ap-south-1",
  bucket: "mdm-stage", 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
